// API URL Configuration
// Handles both preview and production environments
//
// IMPORTANT: For custom domain (dmvsoundstage.com), we MUST use same-origin API calls
// to avoid CORS issues. The production deployment serves both frontend and backend
// from the same domain, so we use relative URLs.

const getApiUrl = () => {
  // Get the current hostname
  const currentHost = typeof window !== 'undefined' ? window.location.hostname : '';
  
  // Production domain check - dmvsoundstage.com uses same-origin backend
  const isProduction = currentHost === 'dmvsoundstage.com' || 
                       currentHost === 'www.dmvsoundstage.com';
  
  if (isProduction) {
    // CRITICAL: Use same-origin for production to avoid CORS issues
    // The backend is served from the same domain via reverse proxy
    return '';  // Empty string = same origin (relative URLs)
  }
  
  // Check the environment variable (set at build time) for preview/dev
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl) {
    return envUrl;
  }
  
  // Fallback: if on localhost, use localhost backend
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    return 'http://localhost:8001';
  }
  
  // Final fallback: use current origin
  return typeof window !== 'undefined' ? window.location.origin : '';
};

// Base URL for the backend (without /api)
export const API_BASE_URL = getApiUrl();

// Full API path (with /api)
export const API = `${API_BASE_URL}/api`;

// For backward compatibility - some components use just the base URL
export const BACKEND_URL = API_BASE_URL;

// Debug logging (always log for troubleshooting production issues)
if (typeof window !== 'undefined') {
  console.log('[API Config] Current host:', window.location.hostname);
  console.log('[API Config] API_BASE_URL:', API_BASE_URL);
  console.log('[API Config] Full API:', API);
}

export default API;
